import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { onMounted } from 'vue';
import { Vue, Component } from 'vue-property-decorator';
import TenantInfo from '@/components/TenantInfo.vue';
import { Tenant } from '../store/models';
import tenantModule from '@/store/modules/tenantModule';

import { defineComponent, ref, computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import useQuasar from 'quasar/src/composables/use-quasar/use-quasar.js';;
import { useI18n } from 'vue-i18n';

const name = 'SmallLayout';

export default /*#__PURE__*/_defineComponent({
  __name: 'SmallLayout',
  setup(__props) {

const route = useRoute();
const router = useRouter();
const store = useStore();
const $q = useQuasar();
const { t, locale } = useI18n();

const tenant = ref<Tenant | null>(null);

  onMounted(async () => {
    loadTenantInfo();
  });

 async function loadTenantInfo() {
    try {
      tenant.value = tenantModule.tenantInfo || null;
      if (!tenant.value) {
        await tenantModule.loadTenantInfo();
        tenant.value = tenantModule.tenantInfo;
      }
    } catch (error) {
      console.log(error);
    }
    if (!tenant.value) {
      router.push({ name: 'invalidtenant' });
    }
  }


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_q_page_container = _resolveComponent("q-page-container")!
  const _component_q_layout = _resolveComponent("q-layout")!

  return (_openBlock(), _createBlock(_component_q_layout, {
    view: "hhh lpr fff",
    class: "bg-grey-3"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_page_container, null, {
        default: _withCtx(() => [
          _createVNode(_component_router_view)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})